import { IEvento, IInputEvento } from '../../common/types/Evento'
import GenericService from '@/shareds/GenericService'
import { IPresenca } from '../../common/types/Presenca'

export const PATH_EVENTO = '/eventos'

class EventoService extends GenericService<IEvento, IInputEvento> {
	constructor() {
		super(PATH_EVENTO)
	}

	async getPresencas(id: string): Promise<IPresenca[]> {
		const { data } = await this.axios.get(`${this.route}/${id}/presencas`)
		return data
	}

}

export default new EventoService()
